import { tickerItems } from '@/mocks/home';

export default function TickerBar() {
  const group = (key: string) => (
    <div className="flex items-center shrink-0" aria-hidden={key === 'clone'}>
      {tickerItems.map((item) => (
        <span key={`${key}-${item}`} className="flex items-center text-sm text-background-50/95">
          <span className="mx-4 text-accent-200">◆</span>
          {item}
        </span>
      ))}
    </div>
  );

  return (
    <section aria-label="今日更新快讯" className="bg-primary-500 text-background-50">
      <div className="flex items-center">
        <div className="shrink-0 flex items-center gap-2 px-4 md:px-8 py-3 bg-primary-600">
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-flashlight-fill text-accent-200" />
          </span>
          <span className="text-sm font-medium whitespace-nowrap tracking-wide">今日快讯</span>
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-ticker">
            {group('main')}
            {group('clone')}
          </div>
          <div className="pointer-events-none absolute inset-y-0 left-0 w-8 bg-gradient-to-r from-primary-500 to-transparent" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-8 bg-gradient-to-l from-primary-500 to-transparent" />
        </div>
      </div>
    </section>
  );
}